import React from 'react';
import { motion } from 'framer-motion';
export function HeaderBar() {
  return <motion.div initial={{
    y: -50,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className="sticky top-0 z-50 bg-gold-main text-white py-3 px-4 text-center shadow-sm" data-id="element-143">
      <div className="max-w-4xl mx-auto flex flex-col items-center justify-center space-y-1" data-id="element-144">
        <p className="font-lora font-medium text-sm md:text-base" data-id="element-145">
          ✨ Lanzamiento especial — Accede hoy al ebook completo + 3 bonos
          exclusivos por solo $9.99 USD
        </p>
        <p className="font-lora text-xs md:text-sm opacity-90" data-id="element-146">
          Entrega inmediata · Descarga digital · Acceso de por vida
        </p>
      </div>
    </motion.div>;
}